import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import { buildComponentName, getComponentPrefix } from '../utils';
import Input from '../input';
import Icon from '../icon';
export default {
  name: buildComponentName('TransferListItem'),
  props: {
    prefixCls: {
      type: String,
      default: "".concat(getComponentPrefix(), "-transfer-list-search")
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerValue: ''
    };
  },
  methods: {
    onInput: function onInput(val) {
      this.innerValue = val;
      this.$emit('input', val);
    },
    onClear: function onClear() {
      this.innerValue = '';
      this.$emit('clear');
    }
  },
  render: function render() {
    var h = arguments[0];
    var $attrs = this.$attrs,
        prefixCls = this.prefixCls,
        disabled = this.disabled,
        innerValue = this.innerValue,
        onInput = this.onInput,
        onClear = this.onClear;
    var props = {
      value: innerValue,
      disabled: disabled
    };
    var icon = innerValue ? h("span", {
      "attrs": {
        "role": "link"
      },
      "class": "".concat(prefixCls, "-action"),
      "on": {
        "click": onClear
      }
    }, [h(Icon, {
      "attrs": {
        "type": "close_circle"
      }
    })]) : h("span", {
      "class": "".concat(prefixCls, "-action")
    }, [h(Icon, {
      "attrs": {
        "type": "search"
      }
    })]);
    return h("div", [h(Input, _mergeJSXProps([{}, {
      class: prefixCls,
      props: props,
      attrs: $attrs,
      on: {
        input: onInput
      }
    }])), icon]);
  }
};